import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TestlistService } from '@app-services/test/testlist.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-subscribe-active',
  templateUrl: './subscribe-active.component.html',
  styleUrls: ['./subscribe-active.component.scss']
})
export class SubscribeActiveComponent implements OnInit {
 
    public message: string;
    examtype = "";
    value= 125;
    public couponCode = 'INFY10';
    private copyCouponCode;
    showCoupon: boolean = false;
    @Input('data') public data:any;
    constructor(
      public activeModal: NgbActiveModal,
      public router: Router,
      private testListService: TestlistService,
      private route: ActivatedRoute)
    { }
  
    ngOnInit(): void {
      let params = {...(this.route.snapshot.queryParams || {})};
      this.examtype = params['examtype']?params['examtype']:'';
      this.message = this.testListService?.subscriptionData?.trialData?.[0]?.description??'Your free plan is over. Please subscribe to our paid plans to continue further.';
      if(this.testListService?.subscriptionData?.subscriptionsList?.length){
       this.message ='Your last subscription has expired. Please subscribe to our paid plans to continue further.';
      }
      if(this.data?.examtype =="SCHOLARSHIPTEST" && !this.examtype){
        this.examtype = "SCHOLARSHIPTEST";
      }
    }
    
    redirectSubscription(){
      this.router.navigate(['/subscription/subscribedPackages'],{state :{'fromModal':true}});
      this.activeModal.close();
    }
  
    copyCoupon(code: any) {
      this.showCoupon = !this.showCoupon;
      this.copyCouponCode = code;
      navigator.clipboard.writeText(this.copyCouponCode);
    }
    close(){    
      // if(!this.router.url.includes('mycourse')){
        this.router.navigate(['/dashboard/liveclass'],{state :{'fromModal':false}});
      // }
      this.activeModal.close();
    }
  
}
